export interface GridColumnStorageScope {
    userId?: number;
    tenantId?: number;
    entityId?: number;
    timeId?: number;
    dataSourceTypeId: number;
    projectId?: number;
    version?: number;
}

export const getGridColumnStorageKey = (
    storagePrefix: string,
    scope: GridColumnStorageScope
): string | undefined => {
    if (
        scope.userId == null ||
        scope.tenantId == null ||
        scope.entityId == null ||
        scope.timeId == null
    ) {
        return undefined;
    }

    return [
        storagePrefix,
        scope.userId,
        scope.tenantId,
        scope.entityId,
        scope.timeId,
        scope.dataSourceTypeId,
        scope.projectId ?? 'none',
        scope.version ?? 'none',
    ].join(':');
};
